import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { putField } from "../../../../../utils/form";
import { callDocumentStatus } from "../../../storage-location/storage-location/storage-location.section";
import store from "../../../../../store";

export const callUserObjective = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery }).then(items => items.filter(item => ["1", "2"].includes(item.key)));

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.release.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.request.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.release.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnDate({
            title: () => i18n.global.t("model.release.transportDate"),
            dataIndex: "transportDate",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.release.releaseDatetime"),
            dataIndex: "releaseDatetime",
            align: "center",
            format: "DD/MM/YYYY HH:mm"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.inform.refOperation"),
            dataIndex: "refInformTemp.refOperation.value",
            inputProp: () => ({ list: callUserObjective, optLabel: "value" }),
            search: { name: "refInformTemp.refOperation.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.release.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
